import { action } from '@ember/object';
import Component from '@glimmer/component';
import PowerSelect from 'ember-power-select/components/power-select';
import type { Locale, LocaleKey } from 'garaje/utils/locale-options';

interface LanguageSelectorSignature {
  Args: {
    isDisabled?: boolean;
    languages: Locale[];
    onChange: (locale: LocaleKey) => void;
    powerSelectClass?: string;
    value: LocaleKey;
  };
  Element: HTMLDivElement;
}

export default class LanguageSelector extends Component<LanguageSelectorSignature> {
  get selectedLanguage(): Locale | undefined {
    return this.args.languages.find((locale) => locale.value === this.args.value);
  }

  @action
  onChange(language: { value: LocaleKey }): void {
    this.args.onChange(language.value);
  }

  <template>
    <div data-test-language-selector ...attributes>
      <PowerSelect
        @options={{@languages}}
        @onChange={{this.onChange}}
        @selected={{this.selectedLanguage}}
        @disabled={{@isDisabled}}
        class={{@powerSelectClass}}
        as |option|
      >
        {{option.label}}
      </PowerSelect>
    </div>
  </template>
}
